import api from "../../api";
import type {
  ContentListingPageData,
  ContentSectionConfig,
  ContentUploadWindow,
  HomeApiItem,
} from "../../../@types/portalAluno";
import {
  mapApiItemsToCards,
  onlyCarouselItems,
} from "../../../utils/portalAluno/mappers/contentCardMapper";

export const getContentListing = async (
  section: ContentSectionConfig,
  offset: number,
  uploadWindow?: ContentUploadWindow | null
): Promise<ContentListingPageData> => {
  const response = await api.get<HomeApiItem[]>("mobile/listagem", {
    params: {
      offset: section.paginated ? offset : 0,
      tipo: section.apiType,
      ...(uploadWindow ? { periodo: uploadWindow } : {}),
    },
  });

  if (!Array.isArray(response.data)) {
    throw new Error("A API retornou uma listagem de conteúdos inválida.");
  }

  const visibleItems =
    section.kind === "cursos" ? onlyCarouselItems(response.data) : response.data;

  return {
    cards: mapApiItemsToCards(visibleItems, section.kind),
    itemCount: response.data.length,
  };
};
